import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, ShadowType, Spacing } from "@snapchat/snap-design-system";

export const cardContainer = css`
    margin-top: 0;
    padding: ${Spacing.LG}px ${Spacing.LG}px;

    /* text-align: center; */
    box-shadow: ${ShadowType.REGULAR};
`;

export const buttonAdderStyle = css`
    align-self: center;
    width: fit-content;

    span {
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.NORMAL};
    }
`;

export const buttonIcon = css`
    margin-right: 5px;
    vertical-align: text-top;
`;

export const ParameterContainer = styled.div`
    padding-top: ${Spacing.XS}px;
    border-bottom: 1px solid ${Colors.Gray.V150};
`;

export const inputStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const controlStyle = css`
    flex: 1 1;

    padding-bottom: ${Spacing.MD}px;

    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
`;

export const deleteStyle = css`
    cursor: pointer;

    display: inline-block;

    padding-bottom: ${Spacing.MD}px;

    font-size: 16px;
    font-weight: ${FontWeight.MEDIUM};
    font-weight: bold;
    line-height: 22px;
    color: #c40a33;

    background: white;
    border: none;
`;

export const subtitle = css`
    padding-bottom: ${Spacing.MD}px;
    font-size: 16px;
    font-weight: ${FontWeight.MEDIUM};
    line-height: 22px;
`;

export const buttonStyle = css`
    position: relative;
    left: 50%;
    transform: translateX(-50%);

    width: fit-content;
    margin-top: ${Spacing.XS}px;

    span {
        font-size: ${FontSizeInPx.REGULAR}px;
        font-weight: ${FontWeight.NORMAL};
    }
`;

export const cardStyle = css`
    text-align: left;

    .sds-card-header {
        .sds-icon {
            box-sizing: border-box;
            margin-left: ${Spacing.MD}px;
            padding: 5px;

            border: 1px solid ${Colors.Gray.V200};
            border-radius: 100px;
        }
    }

    [class*="rightHeaderContent"] {
        display: flex;
        align-items: center;
    }
`;

export const trashButtonIcon = css`
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
`;
